// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datos-vehiculo-list {
  max-height: 60vh;
  /* min-height: 30vh; */
  height: -moz-fit-content;
  height: fit-content;
  overflow-y: scroll;
}

.datos-vehiculo,
.datos-fav {
  display: flex;
  border-top: 1px solid #eaeaea;
  padding: 0;
}

.datos-matricula,
.datos-nom-gas,
.datos-nom-user,
.datos-nom-user-empty {
  font-weight: 600;
}

.datos-nom-user {
  text-transform: capitalize;
}

.datos-nom-user-empty {
  text-align: center;
}

.datos-matricula {
  text-transform: uppercase;
}

.datos-tipo-vehiculo,
.datos-dir-gas,
.datos-dni-user {
  color: #a098ae;
}

.datos-prov-gas {
  font-weight: 700;
}

.datos-start,
.datos-content,
.datos-end {
  align-items: center;
  /* background-color: #fdf4f4; */
  box-shadow: 0px 20px 50px rgba(191, 21, 108, 0.05);
  display: flex;
  padding: 0.8em;
  min-width: 7em;
}

.datos-start,
.datos-gas {
  border-radius: 20px 0 0 20px;
  display: block;
}

.datos-gas {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.datos-end {
  border-radius: 0 20px 20px 0;
}

.datos-mas-btns {
  display: none;
}

.edit-icon-btn {
  width: 23px;
  height: 23px;
}

.delete-icon-btn {
  width: 20px;
  height: 31px;
}

.add-flota-icon-btn {
  width: 33px;
  height: 26px;
}

.reactivate-icon-btn {
  width: 23px;
  height: 23px;
}

.info-img-icon-blocked {
  width: 32px;
  height: 33px;
}

.datos-mas {
  display: flex !important;
  align-items: center;
  justify-content: flex-end;
}

.datos-mas > span {
  color: #a5a5a5;
  font-size: 2.3rem;
  text-align: center;
  width: 100%;
}

.datos-map > div > div {
  border-radius: 0.5em;
}

.datos-precios {
  width: -moz-fit-content;
  width: fit-content;
}

.datos-factura {
  text-align: center;
  width: 100%;
}

.alert.combustible {
  margin-bottom: unset;
  width: 7.5em;
  margin: 0;
}

.datos-btn-favorito {
  cursor: pointer;
}

table.datos-vehiculos th {
  border-bottom: none;
  font-size: 1em;
  color: #2b363b80;
  padding-left: 1.4em;
}

table.datos-gasolinera > :not(:first-child) {
  border-top: none;
}

table.datos-gasolinera span.input-group-text {
  border: none;
}

table.datos-gasolinera tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

table.datos-gasolinera td {
  padding-bottom: 1.7em;
  padding-top: 1.7em;
  vertical-align: middle;
}

input[type="radio"] {
  width: 1.3em;
  height: 1.3em;
}

input[type="radio"]:checked {
  background-color: #fff;
  border-color: #fff;
  box-shadow: none;
}

input[type="radio"]:checked:after,
.form-check-input:checked[type="radio"] {
  /* Heres your symbol replacement - this is a tick in Unicode. */
  content: "\\2605" !important;
  color: #db0b27;
  font-size: 1.5em;
  line-height: 1em;
  text-align: center;
  box-shadow: none;
}

.form-check-input:checked[type="radio"] {
  background-image: none;
}

input[type="radio"]:focus {
  border-color: #fff;
  box-shadow: none;
}

form.search .input-group {
  /* box-shadow: 10px 20px 40px rgb(191 21 108 / 0.1); */
}

form.search .input-group-text {
  /* border: none; */
  border-radius: 0.5em 0 0 0.5em;
}

form.search input {
  border: none;
  border-radius: 0 0.5em 0.5em 0;
}

.form-check-input[type="radio"] {
  border-radius: 0.3em;
}

.form-floating > .form-control:focus,
.form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-select {
  padding-top: 2em;
  padding-left: 1.5em;
}

.form-floating > .form-select {
  padding-top: 1.5em;
}

.alert-blocked {
  display: flex;
  align-items: center;
}

.alert-blocked-icon,
.alert-blocked-text {
  padding: 0 0.5em;
  color: #2b363b80;
}

.alert-blocked-text h6 {
  font-weight: 800;
  font-size: 1.1em;
  margin-bottom: 0;
}

.alert-blocked-text p {
  margin-bottom: 0;
}

.datos-gasolinera-marker-icon {
  width: 27px;
  height: 36px;
}

.data-invoice-icon {
  width: 29px;
  height: 38px;
}

.datos-facturacion-info {
  font-size: 0.8em;
  font-style: italic;
  margin-left: 1em;
  font-weight: 600;
  color: #6c757d;
}

.datos-form-validating {
  position: absolute;
  right: 0;
  top: 1.1em;
}

.datos-form-validating-text {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.table-vehiculos-card,
.datos-gasolinera-card,
.datos-facturacion-card {
  background-color: #fff;
  border-radius: 0.5em;
  padding: 1.5em 1em;
  display: block;
}

.vehicles-sections {
  /* margin-top: 5rem; */
}

#buscadorGasolinera {
  padding: 0 1em;
}

/* BREAKPOINT TABLETS*/
@media (min-width: 768px) {
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  .datos-vehiculo-list {
    max-height: 70vh;
    height: -moz-fit-content;
    height: fit-content;
    min-height: -moz-fit-content;
    min-height: fit-content;
    overflow-x: hidden;
  }

  .datos-vehiculo {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
  }

  h2 {
    font-size: 1.4em;
  }

  .content-section {
    margin-top: 1rem;
    padding-top: 1.5rem;
    padding-left: 1em;
    padding-right: 1em;
  }

  .vehicles-sections {
    padding-left: 3em;
    padding-right: 3em;
  }

  .table-vehiculos-card,
  .datos-gasolinera-card,
  .datos-facturacion-card {
    background-color: #fff;
    border-radius: 0.5em;
    padding: 0;
  }

  .datos-gasolinera-card,
  .datos-facturacion-card {
    display: block;
    padding: 1em;
  }

  .datos-facturacion-card {
    padding: 1.5em 1em;
  }

  .table-vehiculos-card-header {
    padding: 0.5em;
  }

  .content-section form table.datos-gasolinera {
    margin-top: -2rem;
  }

  .content-section table.datos-vehiculos th {
    font-size: 1em;
    color: #2b363b80;
  }

  .datos-start,
  .datos-content,
  .datos-end {
    padding: 0.4em;
  }

  .datos-mas {
    display: none !important;
    align-items: center;
  }

  .datos-mas-btns {
    display: flex !important;
    justify-content: flex-end;
    width: 100%;
    flex-direction: row;
    align-items: center;
  }

  .datos-mas-btns button img:hover {
    filter: invert(48%) sepia(13%) saturate(3207%) hue-rotate(295deg)
      brightness(95%) contrast(320%);
  }

  .datos-precios {
    width: inherit;
    display: flex;
    flex-wrap: nowrap;
    align-items: baseline;
  }

  .datos-precio-gas {
    display: table-cell !important;
  }

  .datos-precio-gas .alert {
    padding-left: 1.3em;
    padding-right: 1.3em;
    width: -moz-fit-content;
    width: fit-content;
  }

  .datos-precios > div {
    margin-right: 0.5rem;
  }

  .icon-bg {
    padding: 1.17em;
    border-radius: 5em;
  }

  .form-group {
    width: 98%;
  }

  form.datos-nuevo-vehiculo .form-group label,
  form.datos-facturacion .form-group label {
    padding-left: 15px;
    padding-top: 15px;
    transition: 0.35s all ease;
  }

  .form-group input,
  .form-group select {
    padding-left: 10px;
  }

  .form-group label {
    padding-left: 5px;
  }

  form.datos-nuevo-vehiculo .form-group input:focus ~ label,
  form.datos-facturacion .form-group input:focus ~ label {
    padding-left: inherit;
    padding-top: 5px;
    transition: 0.35s all ease;
  }

  .form-group input,
  .form-group select {
    height: 3.5em;
    padding-top: 1.8em;
  }

  form.datos-nuevo-vehiculo .form-group input:not(:placeholder-shown) ~ label,
  form.datos-facturacion .form-group input:not(:placeholder-shown) ~ label {
    padding-left: inherit;
    padding-top: 5px;
  }

  form.datos-nuevo-vehiculo .form-group select,
  form.datos-facturacion .form-group select {
    opacity: 0;
  }

  form.datos-nuevo-vehiculo .form-group select.show,
  form.datos-facturacion .form-group select.show {
    transition: 0.55s all ease;
    opacity: 1;
  }

  form.datos-nuevo-vehiculo .form-group select.show ~ label,
  form.datos-facturacion .form-group select.show ~ label {
    padding-top: 5px;
    padding-left: inherit;
  }

  .form-group select:focus {
    padding-top: 1.6em;
  }

  form.datos-facturacion button,
  form.datos-nuevo-vehiculo button,
  .modal-body form button {
    margin: 0 auto;
    min-width: 300px;
    padding-left: 3rem;
    padding-right: 3rem;
    width: -moz-fit-content;
    width: fit-content;
  }

  .form-check-input[type="radio"] {
    border-radius: 4px;
  }

  input[type="radio"] {
    width: 24px;
    height: 24px;
  }

  table.datos-gasolinera input[type="radio"]:checked:after,
  table.datos-gasolinera .form-check-input:checked[type="radio"] {
    font-size: 30px;
    line-height: 23px;
  }
}

@media (min-width: 1200px) {
  .datos-section-right {
    padding: 0 2em;
  }
}

@media (min-width: 1600px) {
  .datos-section-right {
    padding: 0 3em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/datos/datos.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,wBAAmB;EAAnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,+BAA+B;EAC/B,kDAAkD;EAClD,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,+DAA+D;EAC/D,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;;;EAGE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;AACA;;AAEA,0BAA0B;AAC1B;EACE;IACE,gBAAgB;IAChB,wBAAmB;IAAnB,mBAAmB;IACnB,4BAAuB;IAAvB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,6CAA6C;IAC7C,4CAA4C;EAC9C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;;IAGE,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;EACZ;;EAEA;;IAEE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE;oCACgC;EAClC;;EAEA;IACE,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,qBAAqB;IACrB,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;;IAEE,aAAa;IACb,kBAAkB;EACpB;;EAEA;;IAEE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".datos-vehiculo-list {\n  max-height: 60vh;\n  /* min-height: 30vh; */\n  height: fit-content;\n  overflow-y: scroll;\n}\n\n.datos-vehiculo,\n.datos-fav {\n  display: flex;\n  border-top: 1px solid #eaeaea;\n  padding: 0;\n}\n\n.datos-matricula,\n.datos-nom-gas,\n.datos-nom-user,\n.datos-nom-user-empty {\n  font-weight: 600;\n}\n\n.datos-nom-user {\n  text-transform: capitalize;\n}\n\n.datos-nom-user-empty {\n  text-align: center;\n}\n\n.datos-matricula {\n  text-transform: uppercase;\n}\n\n.datos-tipo-vehiculo,\n.datos-dir-gas,\n.datos-dni-user {\n  color: #a098ae;\n}\n\n.datos-prov-gas {\n  font-weight: 700;\n}\n\n.datos-start,\n.datos-content,\n.datos-end {\n  align-items: center;\n  /* background-color: #fdf4f4; */\n  box-shadow: 0px 20px 50px rgba(191, 21, 108, 0.05);\n  display: flex;\n  padding: 0.8em;\n  min-width: 7em;\n}\n\n.datos-start,\n.datos-gas {\n  border-radius: 20px 0 0 20px;\n  display: block;\n}\n\n.datos-gas {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.datos-end {\n  border-radius: 0 20px 20px 0;\n}\n\n.datos-mas-btns {\n  display: none;\n}\n\n.edit-icon-btn {\n  width: 23px;\n  height: 23px;\n}\n\n.delete-icon-btn {\n  width: 20px;\n  height: 31px;\n}\n\n.add-flota-icon-btn {\n  width: 33px;\n  height: 26px;\n}\n\n.reactivate-icon-btn {\n  width: 23px;\n  height: 23px;\n}\n\n.info-img-icon-blocked {\n  width: 32px;\n  height: 33px;\n}\n\n.datos-mas {\n  display: flex !important;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.datos-mas > span {\n  color: #a5a5a5;\n  font-size: 2.3rem;\n  text-align: center;\n  width: 100%;\n}\n\n.datos-map > div > div {\n  border-radius: 0.5em;\n}\n\n.datos-precios {\n  width: fit-content;\n}\n\n.datos-factura {\n  text-align: center;\n  width: 100%;\n}\n\n.alert.combustible {\n  margin-bottom: unset;\n  width: 7.5em;\n  margin: 0;\n}\n\n.datos-btn-favorito {\n  cursor: pointer;\n}\n\ntable.datos-vehiculos th {\n  border-bottom: none;\n  font-size: 1em;\n  color: #2b363b80;\n  padding-left: 1.4em;\n}\n\ntable.datos-gasolinera > :not(:first-child) {\n  border-top: none;\n}\n\ntable.datos-gasolinera span.input-group-text {\n  border: none;\n}\n\ntable.datos-gasolinera tr {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n}\n\ntable.datos-gasolinera td {\n  padding-bottom: 1.7em;\n  padding-top: 1.7em;\n  vertical-align: middle;\n}\n\ninput[type=\"radio\"] {\n  width: 1.3em;\n  height: 1.3em;\n}\n\ninput[type=\"radio\"]:checked {\n  background-color: #fff;\n  border-color: #fff;\n  box-shadow: none;\n}\n\ninput[type=\"radio\"]:checked:after,\n.form-check-input:checked[type=\"radio\"] {\n  /* Heres your symbol replacement - this is a tick in Unicode. */\n  content: \"\\2605\" !important;\n  color: #db0b27;\n  font-size: 1.5em;\n  line-height: 1em;\n  text-align: center;\n  box-shadow: none;\n}\n\n.form-check-input:checked[type=\"radio\"] {\n  background-image: none;\n}\n\ninput[type=\"radio\"]:focus {\n  border-color: #fff;\n  box-shadow: none;\n}\n\nform.search .input-group {\n  /* box-shadow: 10px 20px 40px rgb(191 21 108 / 0.1); */\n}\n\nform.search .input-group-text {\n  /* border: none; */\n  border-radius: 0.5em 0 0 0.5em;\n}\n\nform.search input {\n  border: none;\n  border-radius: 0 0.5em 0.5em 0;\n}\n\n.form-check-input[type=\"radio\"] {\n  border-radius: 0.3em;\n}\n\n.form-floating > .form-control:focus,\n.form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-select {\n  padding-top: 2em;\n  padding-left: 1.5em;\n}\n\n.form-floating > .form-select {\n  padding-top: 1.5em;\n}\n\n.alert-blocked {\n  display: flex;\n  align-items: center;\n}\n\n.alert-blocked-icon,\n.alert-blocked-text {\n  padding: 0 0.5em;\n  color: #2b363b80;\n}\n\n.alert-blocked-text h6 {\n  font-weight: 800;\n  font-size: 1.1em;\n  margin-bottom: 0;\n}\n\n.alert-blocked-text p {\n  margin-bottom: 0;\n}\n\n.datos-gasolinera-marker-icon {\n  width: 27px;\n  height: 36px;\n}\n\n.data-invoice-icon {\n  width: 29px;\n  height: 38px;\n}\n\n.datos-facturacion-info {\n  font-size: 0.8em;\n  font-style: italic;\n  margin-left: 1em;\n  font-weight: 600;\n  color: #6c757d;\n}\n\n.datos-form-validating {\n  position: absolute;\n  right: 0;\n  top: 1.1em;\n}\n\n.datos-form-validating-text {\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-invalid-color);\n}\n\n.table-vehiculos-card,\n.datos-gasolinera-card,\n.datos-facturacion-card {\n  background-color: #fff;\n  border-radius: 0.5em;\n  padding: 1.5em 1em;\n  display: block;\n}\n\n.vehicles-sections {\n  /* margin-top: 5rem; */\n}\n\n#buscadorGasolinera {\n  padding: 0 1em;\n}\n\n/* BREAKPOINT TABLETS*/\n@media (min-width: 768px) {\n}\n\n/* BREAKPOINT ESCRITORIO */\n@media (min-width: 992px) {\n  .datos-vehiculo-list {\n    max-height: 70vh;\n    height: fit-content;\n    min-height: fit-content;\n    overflow-x: hidden;\n  }\n\n  .datos-vehiculo {\n    padding-right: calc(var(--bs-gutter-x) * 0.5);\n    padding-left: calc(var(--bs-gutter-x) * 0.5);\n  }\n\n  h2 {\n    font-size: 1.4em;\n  }\n\n  .content-section {\n    margin-top: 1rem;\n    padding-top: 1.5rem;\n    padding-left: 1em;\n    padding-right: 1em;\n  }\n\n  .vehicles-sections {\n    padding-left: 3em;\n    padding-right: 3em;\n  }\n\n  .table-vehiculos-card,\n  .datos-gasolinera-card,\n  .datos-facturacion-card {\n    background-color: #fff;\n    border-radius: 0.5em;\n    padding: 0;\n  }\n\n  .datos-gasolinera-card,\n  .datos-facturacion-card {\n    display: block;\n    padding: 1em;\n  }\n\n  .datos-facturacion-card {\n    padding: 1.5em 1em;\n  }\n\n  .table-vehiculos-card-header {\n    padding: 0.5em;\n  }\n\n  .content-section form table.datos-gasolinera {\n    margin-top: -2rem;\n  }\n\n  .content-section table.datos-vehiculos th {\n    font-size: 1em;\n    color: #2b363b80;\n  }\n\n  .datos-start,\n  .datos-content,\n  .datos-end {\n    padding: 0.4em;\n  }\n\n  .datos-mas {\n    display: none !important;\n    align-items: center;\n  }\n\n  .datos-mas-btns {\n    display: flex !important;\n    justify-content: flex-end;\n    width: 100%;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .datos-mas-btns button img:hover {\n    filter: invert(48%) sepia(13%) saturate(3207%) hue-rotate(295deg)\n      brightness(95%) contrast(320%);\n  }\n\n  .datos-precios {\n    width: inherit;\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: baseline;\n  }\n\n  .datos-precio-gas {\n    display: table-cell !important;\n  }\n\n  .datos-precio-gas .alert {\n    padding-left: 1.3em;\n    padding-right: 1.3em;\n    width: fit-content;\n  }\n\n  .datos-precios > div {\n    margin-right: 0.5rem;\n  }\n\n  .icon-bg {\n    padding: 1.17em;\n    border-radius: 5em;\n  }\n\n  .form-group {\n    width: 98%;\n  }\n\n  form.datos-nuevo-vehiculo .form-group label,\n  form.datos-facturacion .form-group label {\n    padding-left: 15px;\n    padding-top: 15px;\n    transition: 0.35s all ease;\n  }\n\n  .form-group input,\n  .form-group select {\n    padding-left: 10px;\n  }\n\n  .form-group label {\n    padding-left: 5px;\n  }\n\n  form.datos-nuevo-vehiculo .form-group input:focus ~ label,\n  form.datos-facturacion .form-group input:focus ~ label {\n    padding-left: inherit;\n    padding-top: 5px;\n    transition: 0.35s all ease;\n  }\n\n  .form-group input,\n  .form-group select {\n    height: 3.5em;\n    padding-top: 1.8em;\n  }\n\n  form.datos-nuevo-vehiculo .form-group input:not(:placeholder-shown) ~ label,\n  form.datos-facturacion .form-group input:not(:placeholder-shown) ~ label {\n    padding-left: inherit;\n    padding-top: 5px;\n  }\n\n  form.datos-nuevo-vehiculo .form-group select,\n  form.datos-facturacion .form-group select {\n    opacity: 0;\n  }\n\n  form.datos-nuevo-vehiculo .form-group select.show,\n  form.datos-facturacion .form-group select.show {\n    transition: 0.55s all ease;\n    opacity: 1;\n  }\n\n  form.datos-nuevo-vehiculo .form-group select.show ~ label,\n  form.datos-facturacion .form-group select.show ~ label {\n    padding-top: 5px;\n    padding-left: inherit;\n  }\n\n  .form-group select:focus {\n    padding-top: 1.6em;\n  }\n\n  form.datos-facturacion button,\n  form.datos-nuevo-vehiculo button,\n  .modal-body form button {\n    margin: 0 auto;\n    min-width: 300px;\n    padding-left: 3rem;\n    padding-right: 3rem;\n    width: fit-content;\n  }\n\n  .form-check-input[type=\"radio\"] {\n    border-radius: 4px;\n  }\n\n  input[type=\"radio\"] {\n    width: 24px;\n    height: 24px;\n  }\n\n  table.datos-gasolinera input[type=\"radio\"]:checked:after,\n  table.datos-gasolinera .form-check-input:checked[type=\"radio\"] {\n    font-size: 30px;\n    line-height: 23px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .datos-section-right {\n    padding: 0 2em;\n  }\n}\n\n@media (min-width: 1600px) {\n  .datos-section-right {\n    padding: 0 3em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
